import { Injectable } from '@angular/core';
import { getTenantConfig } from '../utils/tenant-context';
import type { TenantBrandingAssets } from '../utils/tenant-registry';

export type BrandingAssets = TenantBrandingAssets;

@Injectable({
  providedIn: 'root'
})
export class BrandingService {
  getAssets(): BrandingAssets {
    return getTenantConfig().branding;
  }
}
